import React, { PureComponent, Fragment } from 'react';
import { Helmet } from "react-helmet";
import renderHTML from 'react-render-html';
import Header from 'components/header/header.component';
import GoogleMaps from "simple-react-google-maps"

import {
  StyledContent,
  StyledContactColumn,
  StyledMap,
  StyledLocaleWrapper,
} from "./contact.style";

import {
  StyledElementHeaderTitle,
  StyledElementHeaderDescription,
  StyledElementWrapperCenter,
  StyledElementWrapper,
} from 'styledElements';


// Texts
import text from 'i18l';

// Icons
import IconPhone from 'icons/phone.icon';
import IconMail from 'icons/mail.icon';

class ContactComponent extends PureComponent {
  componentDidMount() {
    window.scrollTo(0,0);
  }

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>Kontakt | Myjnia bezdotykowa Koło myjniakolo.pl</title>
          <meta name="description" content="Myjnia bezdotykowa Koło zaprasza! W ofercie bogaty wybór programów m.in. mycie felg, aktywna piana, turbo szczotka, spłukiwanie, woskowanie oraz nabłyszczanie." />
        </Helmet>
        <Header/>
        <StyledElementWrapper>
          <StyledElementWrapperCenter>
            <header>
              <StyledElementHeaderTitle>
                {text.CONTACT.TITLE}
              </StyledElementHeaderTitle>
              <StyledElementHeaderDescription>
                {text.CONTACT.DESCRIPTION}
              </StyledElementHeaderDescription>
            </header>
            <div itemScope itemType="https://schema.org/LocalBusiness">
              <StyledContent>
                <StyledContactColumn>
                  <IconPhone/>
                  <span itemProp="telephone">{renderHTML(text.FOOTER.PHONE)}</span>
                </StyledContactColumn>
                <StyledContactColumn>
                  <IconMail/>
                  <span itemProp="email">{renderHTML(text.FOOTER.MAIL)}</span>
                </StyledContactColumn>
              </StyledContent>
            </div>

          </StyledElementWrapperCenter>
        </StyledElementWrapper>
        <StyledLocaleWrapper>
          <StyledElementWrapperCenter>
            <header>
              <StyledElementHeaderTitle>
                {text.CONTACT.TITLE_LOCALE}
              </StyledElementHeaderTitle>
              <StyledElementHeaderDescription>
                {text.CONTACT.DESCRIPTION_LOCALE}
              </StyledElementHeaderDescription>
            </header>
          </StyledElementWrapperCenter>

        <StyledMap>

          <GoogleMaps
            apiKey={"AIzaSyDy0MsLWyVTEvE89u1qK-2vOq0Mba063I0"}
            style={{height: "500px", width: "100%"}}
            zoom={15}
            center={{lat: 52.197899, lng: 18.640980}}
            markers={{lat: 52.197899, lng: 18.640980}}
          />
        </StyledMap>
        </StyledLocaleWrapper>
      </Fragment>
    );
  }
}

export default ContactComponent;


// WEBPACK FOOTER //
// ./src/routes/contact/contact.component.js